import { useState, useEffect } from "react";
import { contentAPI } from "../api/endpoints";
import HeroSlider from "../components/HeroSlider";
import ContentRow from "../components/ContentRow";
import PageSkeleton from "../components/PageSkeleton";

export default function Home() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    contentAPI
      .getHome()
      .then((res) => {
        // /api/launcher returns an array of MovieContentResponse
        // Each has: id, title, type, layout_type, data (list of movies)
        setSections(res.data || []);
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <PageSkeleton withHero={true} />;
  }

  // Find banner section for hero slider
  const bannerSection = sections.find(
    (s) => s.layout_type === "banner" || s.layout_type === "slider"
  );

  // Filter out live TV and banner sections from content rows
  const contentSections = sections.filter(
    (s) =>
      s.layout_type !== "banner" &&
      s.layout_type !== "slider" &&
      s.type !== "livetv"
  );

  return (
    <div className="min-h-screen bg-dark-900">
      {/* Hero Slider */}
      {bannerSection && <HeroSlider slides={bannerSection.data || []} />}

      {/* Content Rows */}
      <div className="pt-8 pb-16">
        {contentSections.map((section, index) => (
          <ContentRow
            key={`${section.id || section.title || section.type || "section"}-${index}`}
            title={section.title}
            items={section.data || []}
            type={section.type}
          />
        ))}
      </div>
    </div>
  );
}
